
if (!customElements.get('image-slider')) {
  class MainSlider extends HTMLElement {
    constructor() {
      super()
      this.list = this.firstElementChild;
      this.slides = [...this.list.children]
      this.switchButtons = this.querySelectorAll('button');
      this.index;

      this.setupIntersectionObserver();
      this.setupSwitchButtons();
    }

    setupIntersectionObserver() {
      const sliderScrollObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.index = parseInt(entry.target.dataset.index);
              this.setActiveButton();
            }
          });
        },
        {
          threshold: 0.7,
        }
      );

      this.slides.forEach((slide) => {
        sliderScrollObserver.observe(slide);
      });
    }

    setupSwitchButtons() {
      this.switchButtons.forEach((btn, index) => {
        btn.addEventListener('click', () => {
          this.switchingSlides(index)
        })
      })
    }

    switchingSlides(index) {
      const scrollAmount = this.slides[0].clientWidth;
      this.list.scrollLeft += (index === 0 ? -scrollAmount : scrollAmount);
    }

    setActiveButton() {
      let size = this.slides.length - 1;
      this.index === 0
        ? (this.switchButtons[0].setAttribute('data-active', 'false'))
        : (this.switchButtons[0].setAttribute('data-active', 'true'));

      this.index === size
        ? (this.switchButtons[1].setAttribute('data-active', 'false'))
        : (this.switchButtons[1].setAttribute('data-active', 'true'));
    }

  }

  customElements.define('image-slider', MainSlider);
}
